import { Controller, useFormContext } from 'react-hook-form';
import { Button, COLOR_WARNING_50, Else, IconAlertTriangle, IconEdit, IfElse, InputField, Text, Then } from '@consumidor-positivo/aurora';
import { currencyMask } from '@libs/utils/masks/currency';

import { useMonthlyExpense } from './hook';
import '../styles.scss';

export type MonthlyExpenseStepProps = {
  negativeDebts?: any[];
};

export const MonthlyExpenseStep = ({ negativeDebts }: MonthlyExpenseStepProps) => {
  const { control } = useFormContext();
  const { fieldValidators, showNegativeDebtsWarning, goToNegativeDebts, handleIgnoreNegativeDebts, handleOnBlur } = useMonthlyExpense({
    negativeDebts,
  });

  const fieldName = 'monthly_expense';

  return (
    <div className="mm-form__step">
      <div className="mm-form__step--monthly-expense">
        <IfElse condition={!showNegativeDebtsWarning}>
          <Then>
            <>
              <div className="form-container">
                <Text as="h2" variant="heading-small" variantDesk="heading-medium" weight="bold">
                  Para continuar, digite o valor do seu gasto mensal no cartão de crédito:
                </Text>
                <Text as="p" variant="body-medium">
                  Vamos usar este valor para calcular os benefícios que você vai ter com o cartão
                </Text>
              </div>
              <div className="form-container">
                <Controller
                  name={fieldName}
                  control={control}
                  rules={fieldValidators}
                  render={({ field, formState: { errors } }) => {
                    return (
                      <InputField
                        {...field}
                        required
                        showOptionalLabel={false}
                        label="Valor de gasto mensal"
                        placeholder="R$ 2.000,00"
                        onChange={(e) => field.onChange(currencyMask(e.target.value))}
                        onBlur={handleOnBlur}
                        error={Boolean(errors?.[fieldName])}
                        errorMessage={String(errors?.[fieldName]?.message)}
                        rightSlot={<IconEdit />}
                      />
                    );
                  }}
                />
                <Button htmlType="submit" expand="x">
                  Seguir com este valor
                </Button>
              </div>
            </>
          </Then>
          <Else>
            <div className="mm-form__step--monthly-expense negative-user-container">
              <div className="mm-form__step--monthly-expense">
                <Text as="h2" variant="heading-small" variantDesk="heading-medium" weight="bold">
                  Prontinho! Vimos que...
                </Text>
                <div className="highlight highlight--alert">
                  <IconAlertTriangle rawColor={COLOR_WARNING_50} />
                  <Text as="h2" variant="heading-micro" variantDesk="heading-small">
                    Você tem <strong>{negativeDebts?.length} negativações</strong> na Boa Vista
                  </Text>
                </div>
                <div className="form-content-container">
                  <Text as="p" variant="body-medium" color="secondary">
                    Infelizmente, <strong>negativações diminuem muito suas chances de ser aprovado</strong> em um cartão de crédito.
                  </Text>
                  <Text as="p" variant="body-medium" color="secondary">
                    Recomendamos que <strong>primeiro quite suas dívidas negativadas</strong> e depois venha descobrir seu cartão ideal :)
                  </Text>
                </div>
              </div>

              <div className="form-content-container">
                <Button expand="x" onClick={goToNegativeDebts}>
                  Ver minhas negativações
                </Button>
                <Button expand="x" type="ghost" onClick={handleIgnoreNegativeDebts}>
                  Quero ver os cartões primeiro
                </Button>
              </div>
            </div>
          </Else>
        </IfElse>
      </div>
    </div>
  );
};
